import React, { useState, useRef, useEffect } from "react";
import "./ChiefDashbord.css";
import axios from "axios";
import moment from "jalali-moment";
import { BiLogOut, BiTrash } from "react-icons/bi";
import { RiSearch2Line } from "react-icons/ri";
import { BsPlusSquare } from "react-icons/bs";
import ChiefDashbord_filters from "./ChiefDashbord_filters/ChiefDashbord_filters";
import DropDown2 from "../../../Components/DropDown2/DropDown2";
import CheckBox from "../../../Components/CheckBox/CheckBox";
import ProfileImage from "../../../user.png";
import ChiefDashbord_Chart from "./ChiefDashbord_Chart";
import ChiefDashbord_Text from "./ChiefDashbord_Text";
import ReportBox from "../../../Components/ReportBox/ReportBox";
import { HiMenu } from "react-icons/hi";
import PersonBox from "../../../Components/PersonBox/PersonBox";
import Drawer from "@mui/material/Drawer";
import useDocumentTitle from "../../../Components/TitleSetter/useDocumentTitle";
import ChiefDashbord_sidebar_res from "../sidebar/ChiefDashbord_sidebar_res";
import ChiefDashbord_sidebar from "../sidebar/ChiefDashbord_sidebar";

function ChiefDashbord() {
    useDocumentTitle("باهم | داشبورد کاربر ارشد");
    const [DP_DrawerB, setDP_DrawerB] = useState(false);

    const header = useRef(null);
    useEffect(() => {
        header.current.scrollIntoView({ behavior: "smooth" });
    }, []);

    const [reportList, setReportList] = useState([]);
    useEffect(() => {
        axios
            .get("https://hammaskan.ir:8443/api/reports/allReports", {
                params: {
                    perPage: 20,
                    page: 0,
                    sort: -1,
                },
            })
            .then((res) => {
                console.log(res.data.data);
                setReportList(res.data.data);
            })
            .catch((error) => {
                // console.log(error);
            });
    }, []);

    return (
        <div className="ChiefDashbord" ref={header}>
            <div className="ChiefDashbord_SidebarContainer">
                <ChiefDashbord_sidebar ChiefName="کاربر مدیر ارشد" path="" userProfile={ProfileImage} sidebar={6} />
            </div>
            <div className="ChiefDashbord_Feed">
                <div className="ChiefDashbord_FeedHeader">
                    <div className="ChiefDashbord_FeedHeaderTitleContainer">
                        <div className="ChiefDashbord_sideBarOpenIconContainer" onClick={() => setDP_DrawerB(true)}>
                            <HiMenu className="ChiefDashbord_sideBarOpenIcon" />
                        </div>
                        <div className="ChiefDashbord_FeedHeaderTitleBor"></div>
                        <span className="ChiefDashbord_FeedHeaderTitle">داشبورد مدیر ارشد</span>
                    </div>

                    <div className="ChiefDashbord_FeedHeaderLogin">
                        <span className="ChiefDashbord_FeedHeaderLoginTitle1">وارد شده به عنوان</span>
                        <span className="ChiefDashbord_FeedHeaderLoginTitle2">مدیر ارشد</span>
                        <div className="ChiefDashbord_FeedHeaderLogout">
                            <span className="ChiefDashbord_FeedHeaderLogoutTitle">خروج</span>
                            <div className="ChiefDashbord_FeedHeaderLogoutIcon">
                                <BiLogOut />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ChiefDashbord_FeedContent">
                    <div className="ChiefDashbord_FeedContentEvaluationContainer">
                        <div className="ChiefDashbord_FeedContentEvaluationTitles">
                            <div className="ChiefDashbord_FeedContentEvaluationTitleContainer">
                                <div className="ChiefDashbord_FeedContentEvaluationTitleIcon">
                                    <RiSearch2Line />
                                </div>

                                <span className="ChiefDashbord_FeedContentEvaluationTitle">ارزیابی</span>
                            </div>
                            <span className="ChiefDashbord_FeedContentEvaluationTitleDescribe">مدیریت ارزیابی</span>
                        </div>
                    </div>
                    <ChiefDashbord_filters />

                    {reportList.length !== 0 ? (
                        <div className="ChiefDashbord_FeedBuildings" style={{ marginBottom: "64px" }}>
                            <div className="ChiefDashbord_FeedBuildingstitles" style={{ display: "flex" }}>
                                <span className="ChiefDashbord_FeedBuildingstitle1" style={{ flexGrow: 1 }}>
                                    ردیف
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle2" style={{ flexGrow: 3, minWidth: "250px" }}>
                                    کد درخواست
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle3" style={{ flexGrow: 2 }}>
                                    نام مالک
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle4" style={{ flexGrow: 2, minWidth: "150px" }}>
                                    کارشناس بازدید
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle5" style={{ flexGrow: 2, minWidth: "150px" }}>
                                    سازنده
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle6" style={{ flexGrow: 2 }}>
                                    وضعیت
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle7" style={{ flexGrow: 2, minWidth: "140px" }}>
                                    پرداخت
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle8" style={{ flexGrow: 2, maxWidth: "190px" }}>
                                    عملیات
                                </span>
                            </div>
                            {reportList.map(function (item, i) {
                                return <ReportBox data={item} index={i} />;
                            })}
                        </div>
                    ) : (
                        <div className="ChiefDashbord_FeedBuildings" style={{ marginBottom: "42px" }}>
                            <div className="ChiefDashbord_FeedBuildingstitles" style={{ display: "flex" }}>
                                <span className="ChiefDashbord_FeedBuildingstitle1" style={{ flexGrow: 1 }}>
                                    ردیف
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle2" style={{ flexGrow: 12 }}>
                                    کد درخواست
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle3" style={{ flexGrow: 2 }}>
                                    نام مالک
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle4" style={{ flexGrow: 2 }}>
                                    کارشناس بازدید
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle5" style={{ flexGrow: 2 }}>
                                    سازنده
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle6" style={{ flexGrow: 2 }}>
                                    وضعیت
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle7" style={{ flexGrow: 2 }}>
                                    پرداخت
                                </span>
                                <span className="ChiefDashbord_FeedBuildingstitle8" style={{ flexGrow: 2 }}>
                                    عملیات
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Drawer className="Links_DrawerChiefBoard" anchor={"right"} open={DP_DrawerB} onClose={() => setDP_DrawerB(false)}>
                <div className="Links_DrawerChiefBoardContainer">
                    <ChiefDashbord_sidebar_res setDP_DrawerB={setDP_DrawerB} ChiefName="متین نوروزپور" path="" marginTop="0px" userProfile={ProfileImage} sidebar={6} />
                </div>
            </Drawer>
        </div>
    );
}

export default ChiefDashbord;
